(function(){
  "use strict";

  var LIMIT = 8;
  var cartItems = [];
  var upsellProducts = [];
  var justAddedProduct = null;
  var selState = {};

  /* ===== COLOR MAP ===== */
  var exactColors = {
    "black":"#000000","jet black":"#000000","onyx":"#353839","carbon":"#222222",
    "charcoal":"#36454f","ebony":"#262626","ink":"#111111",
    "white":"#ffffff","snow":"#fffafa","ivory":"#fffff0","cream":"#fffdd0",
    "off white":"#faf9f6","off-white":"#faf9f6","pearl":"#f8f6f0",
    "grey":"#9b9b9b","gray":"#9b9b9b","light grey":"#d3d3d3","light gray":"#d3d3d3",
    "dark grey":"#555555","dark gray":"#555555","silver":"#c0c0c0",
    "blue":"#3f6fb5","navy":"#172554","navy blue":"#172554","dark blue":"#12315b",
    "light blue":"#9fc5e8","sky blue":"#87ceeb","royal blue":"#4169e1",
    "indigo":"#4b0082","midnight blue":"#191970","denim":"#3f5f8f",
    "dusty blue":"#6f8fa6","soft blue":"#9bb7d4",
    "green":"#4f7942","dark green":"#285430","light green":"#90ee90",
    "sage":"#9caf88","sage green":"#9caf88","olive":"#808000","olive green":"#6b8e23",
    "forest green":"#228b22","emerald":"#50c878","mint":"#98ff98",
    "teal":"#008080","dark teal":"#004c4c","dusty green":"#7f9b82","soft green":"#a8c3a0",
    "red":"#d93636","dark red":"#8b0000","light red":"#ff7f7f","maroon":"#800000",
    "burgundy":"#800020","wine":"#722f37","rust":"#b7410e","cherry red":"#d2042d",
    "pink":"#e8a0ad","light pink":"#ffb6c1","dark pink":"#c2185b","rose":"#d67c8a",
    "dusty rose":"#c08081","blush":"#de8c9a","fuchsia":"#d946ef","magenta":"#d946ef",
    "dusty pink":"#d8a0a6","soft pink":"#f4b6c2","powder pink":"#f4c2c2",
    "purple":"#87529a","dark purple":"#4b0082","light purple":"#d8b4fe",
    "violet":"#8f00ff","lavender":"#c4b5d8","mauve":"#b7849b",
    "orange":"#d98236","dark orange":"#c45b12","light orange":"#ffb347",
    "coral":"#f0806a","peach":"#f4b183","soft coral":"#eaa08b",
    "yellow":"#e5c33b","dark yellow":"#b8860b","mustard":"#c9a227","gold":"#d4af37",
    "brown":"#6b4a35","dark brown":"#4a3022","light brown":"#c4a484",
    "chocolate":"#7b3f00","coffee":"#6f4e37","mocha":"#967969",
    "tan":"#c9a875","beige":"#d8c3a5","light beige":"#eee5d3",
    "camel":"#c19a6b","nude":"#d8aa88","almond":"#e3d0bb","khaki":"#b8ad87",
    "stone":"#928e85","taupe":"#8b8178","greige":"#b3ada7","sand":"#c2b280",
    "ash":"#b2beb5","slate":"#708090"
  };

  function norm(n) { return String(n||"").toLowerCase().trim().replace(/[_\-]+/g," ").replace(/\s+/g," "); }
  function colorCSS(name) {
    if (!name) return "#a8a29e";
    if (name.startsWith("#")) return name;
    var n = norm(name);
    if (exactColors[n]) return exactColors[n];
    for (var k in exactColors) { if (n.includes(k)) return exactColors[k]; }
    return name;
  }
  function isLight(name) {
    var n = norm(name);
    return ["white","cream","beige","sand","ivory","nude","blush","off white","light pink","pearl","almond"].some(function(x){return n.includes(x);});
  }

  /* ===== FORMAT PRICE (Indian: dots for thousands) ===== */
   /* ===== FORMAT PRICE — Indian commas: ₹2,900 or ₹1,74,900 ===== */
  function fmtPrice(price) {
    var sym = (window.upsellConfig && window.upsellConfig.currencySymbol) || "₹";
    var num = Math.round(Number(price) || 0);
    var str = String(num);
    if (str.length <= 3) return sym + str;
    var last3 = str.substring(str.length - 3);
    var rest = str.substring(0, str.length - 3);
    var parts = [];
    while (rest.length > 2) {
      parts.unshift(rest.substring(rest.length - 2));
      rest = rest.substring(0, rest.length - 2);
    }
    if (rest.length > 0) parts.unshift(rest);
    return sym + parts.join(",") + "," + last3;
  }

  /* ===== FETCH PRODUCT VIA SHOPIFY AJAX API ===== */
  function fetchProductByHandle(handle) {
    console.log("[fetchProduct] Fetching:", handle);
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function(r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function(p) {
        console.log("[fetchProduct] Got:", p.title, "| options:", p.options.map(function(o){return o.name;}));
        return normalizeFromAPI(p);
      })
      .catch(function(e) {
        console.error("[fetchProduct] Error fetching", handle, e);
        return null;
      });
  }

  /* ===== NORMALIZE FROM SHOPIFY API ===== */
   /* ===== NORMALIZE FROM SHOPIFY API ===== */
  function normalizeFromAPI(p) {
    var colors = [], sizes = [], colorImages = [], colorPos = 0, sizePos = 0;

    if (p.options && p.options.length > 0) {
      for (var i = 0; i < p.options.length; i++) {
        var o = p.options[i];
        var n = (o.name || "").toLowerCase();
        if (n.indexOf("color") !== -1 || n.indexOf("colour") !== -1) {
          colorPos = i + 1;
          colors = o.values || [];
        }
        if (n.indexOf("size") !== -1) {
          sizePos = i + 1;
          sizes = o.values || [];
        }
      }
    }

    var variants = [];
    var seenColors = {};
    if (p.variants && p.variants.length > 0) {
      for (var j = 0; j < p.variants.length; j++) {
        var v = p.variants[j];
        variants.push({
          id: v.id,
          available: v.available,
          opt1: v.option1 || "",
          opt2: v.option2 || "",
          opt3: v.option3 || ""
        });
        if (colorPos > 0) {
          var c = "";
          if (colorPos === 1) c = v.option1 || "";
          else if (colorPos === 2) c = v.option2 || "";
          else if (colorPos === 3) c = v.option3 || "";
          if (c && !seenColors[c]) {
            seenColors[c] = true;
            var vImg = v.featured_image ? v.featured_image.src : "";
            colorImages.push({
              name: c,
              img: vImg ? vImg.replace(".jpg", "_60x.jpg").replace(".png", "_60x.png") : "",
              fullImg: vImg ? vImg.replace(".jpg", "_400x.jpg").replace(".png", "_400x.png") : ""
            });
          }
        }
      }
    }

    var featuredImg = "";
    if (p.featured_image) {
      featuredImg = p.featured_image.replace(".jpg", "_400x.jpg").replace(".png", "_400x.png");
    }

    // ===== PRICE FIX =====
    // Shopify API returns prices in cents/paise for some stores
    // If value > 10000, it's in smallest unit — divide by 100
    var rawSale = Number(p.price) || 0;
    var rawCompare = Number(p.compare_at_price_max) || 0;

    var salePrice, comparePrice;
    if (rawSale > 10000) {
      // Price in paise/cents — divide by 100
      salePrice = Math.round(rawSale / 100);
      comparePrice = rawCompare > 10000 ? Math.round(rawCompare / 100) : Math.round(rawCompare);
    } else {
      // Price already in currency units
      salePrice = Math.round(rawSale);
      comparePrice = Math.round(rawCompare);
    }
    if (comparePrice <= salePrice) comparePrice = 0;

    console.log("[normalize]", p.title, "| rawSale:", rawSale, "→ salePrice:", salePrice, "| rawCompare:", rawCompare, "→ comparePrice:", comparePrice, "| colors:", colors.length, "| sizes:", sizes.length);

    return {
      id: p.id,
      handle: p.handle,
      name: p.title,
      comparePrice: comparePrice,
      salePrice: salePrice,
      img: featuredImg,
      url: "/products/" + p.handle,
      colors: colors,
      sizes: sizes,
      colorImages: colorImages,
      variants: variants
    };
  }

  /* ===== CART ===== */
  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function(r) { return r.json(); })
      .then(function(c) {
        cartItems = (c.items || []).map(function(i) {
          return { variantId: i.variant_id, productId: i.product_id, qty: i.quantity, handle: i.handle };
        });
        return c;
      })
      .catch(function(e) { console.error("[fetchCart]", e); return { items: [] }; });
  }
  function inCart(pid) { return cartItems.some(function(c) { return c.productId === pid; }); }
  function cartCount() { return cartItems.reduce(function(s, c) { return s + c.qty; }, 0); }
  function addToCartAPI(vid, qty) {
    console.log("[addToCart] variant:", vid);
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: vid, quantity: qty || 1 }),
      credentials: "same-origin"
    }).then(function(r) { return r.json(); });
  }

  /* ===== VARIANT HELPERS ===== */
  function findVariant(p, color, size) {
    var hasC = p.colors && p.colors.length > 0;
    var hasS = p.sizes && p.sizes.length > 0;
    var m = p.variants.find(function(v) {
      if (hasC && hasS) return (v.opt1===color||v.opt2===color||v.opt3===color) && (v.opt1===size||v.opt2===size||v.opt3===size);
      if (hasS) return v.opt1===size || v.opt2===size || v.opt3===size;
      if (hasC) return v.opt1===color || v.opt2===color || v.opt3===color;
      return true;
    });
    if (m && m.available) return m;
    return p.variants.find(function(v) { return v.available; }) || p.variants[0];
  }

  function getAvailSizes(p, color) {
    if (!p.colors || p.colors.length === 0) return p.sizes || [];
    return (p.sizes || []).filter(function(size) {
      return p.variants.some(function(v) {
        return (v.opt1===color||v.opt2===color||v.opt3===color) && (v.opt1===size||v.opt2===size||v.opt3===size) && v.available;
      });
    });
  }

  function savePct(p) {
    if (!p.comparePrice || p.comparePrice <= p.salePrice) return 0;
    return Math.round((1 - p.salePrice / p.comparePrice) * 100);
  }

  /* ===== GET UPSELL PRODUCTS ===== */
  function getUpsellProducts(excludeHandle) {
    var config = window.upsellConfig || {};
    var handles = config.metaHandles || [];

    console.log("[getUpsellProducts] handles from Liquid:", handles.length, handles);

    // Filter out the current product
    handles = handles.filter(function(h) { return h && h !== excludeHandle; }).slice(0, LIMIT);
    console.log("[getUpsellProducts] After filter:", handles.length, handles);

    if (handles.length === 0) {
      // Fallback: Recommendations API
      var pid = config.currentProductId;
      if (pid) {
        console.log("[getUpsellProducts] Fallback: recommendations API for product", pid);
        return fetch("/recommendations/products.json?product_id=" + pid + "&limit=" + LIMIT + "&intent=related", { credentials: "same-origin" })
          .then(function(r) { return r.json(); })
          .then(function(d) {
            var prods = (d.products || []).filter(function(p) { return p.handle !== excludeHandle; }).slice(0, LIMIT);
            console.log("[getUpsellProducts] API returned:", prods.length);
            return prods.map(normalizeFromAPI).filter(Boolean);
          })
          .catch(function(e) { console.error("[getUpsellProducts] API error:", e); return []; });
      }
      console.warn("[getUpsellProducts] No handles AND no product ID. Returning empty.");
      return Promise.resolve([]);
    }

    // Fetch each product by handle via AJAX
    console.log("[getUpsellProducts] Fetching", handles.length, "products by handle...");
    var promises = handles.map(function(h) { return fetchProductByHandle(h); });

    return Promise.all(promises).then(function(results) {
      var valid = results.filter(Boolean);
      console.log("[getUpsellProducts] Successfully loaded:", valid.length, "products");
      return valid;
    });
  }

  /* ===== BUILD CARD HTML ===== */
  function buildCard(p) {
    var ic = inCart(p.id);
    var sv = savePct(p);
    var st = selState[p.id];
    var availSizes = getAvailSizes(p, st.color);

    // ===== USE SELECTED COLOR'S IMAGE AS MAIN IMAGE =====
    var mainImg = p.img;
    if (st.color && p.colorImages && p.colorImages.length > 0) {
      var colorMatch = p.colorImages.find(function(c) { return c.name === st.color; });
      if (colorMatch && colorMatch.fullImg) {
        mainImg = colorMatch.fullImg;
      }
    }

    // Colors — circles
    var colorsHTML = "";
    if (p.colors && p.colors.length > 0) {
      colorsHTML = '<div class="um-colors">';
      for (var ci = 0; ci < p.colors.length; ci++) {
        var c = p.colors[ci];
        var pk = st.color === c ? "picked" : "";
        var bg = "background:" + colorCSS(c) + ";";
        var lb = isLight(c) ? "box-shadow:inset 0 0 0 1px #d6d3d1;" : "";
        colorsHTML += '<button class="um-csw ' + pk + '" style="' + bg + lb + '" data-pid="' + p.id + '" data-val="' + c + '" data-type="color" title="' + c + '"></button>';
      }
      colorsHTML += '</div>';
    }

    // Sizes
    var sizesHTML = "";
    if (p.sizes && p.sizes.length > 0) {
      sizesHTML = '<div class="um-sizes">';
      for (var si = 0; si < p.sizes.length; si++) {
        var s = p.sizes[si];
        var av = availSizes.indexOf(s) !== -1;
        var pk = st.size === s && av ? "picked" : "";
        var dis = av ? "" : "disabled";
        sizesHTML += '<button class="um-sch ' + pk + '" data-pid="' + p.id + '" data-val="' + s + '" data-type="size" ' + dis + '>' + s + '</button>';
      }
      sizesHTML += '</div>';
    }

    var saveBadge = sv > 0 ? '<span class="um-save">SAVE ' + sv + '%</span>' : '';
    var cartBadge = ic ? '<span class="um-ck"><svg viewBox="0 0 24 24"<polyline points="20 6 9 17 4 12"/></svg></span>' : '';
    var addClass = ic ? "added" : "";
    var addText = ic ? "ADDED ✓" : "ADD";
    var colorNameHTML = st.color ? '<div class="um-color-name">' + st.color + '</div>' : '';
    var origHTML = p.comparePrice > 0 ? '<span class="um-orig">' + fmtPrice(p.comparePrice) + '</span>' : '';

    return '<div class="um-card" data-pid="' + p.id + '">' +
      '<div class="um-card-img" onclick="window.location.href=\'' + p.url + '\'">' +
        '<img src="' + mainImg + '" alt="' + p.name + '" loading="lazy" style="transition:opacity 200ms ease;">' +
        saveBadge + cartBadge +
      '</div>' +
      '<div class="um-card-info">' +
        '<h4 onclick="window.location.href=\'' + p.url + '\'">' + p.name + '</h4>' +
        '<div class="um-prices"><span class="um-sale">' + fmtPrice(p.salePrice) + '</span>' + origHTML + '</div>' +
        colorNameHTML +
        colorsHTML +
        sizesHTML +
        '<button class="um-add ' + addClass + '" data-pid="' + p.id + '">' + addText + '</button>' +
      '</div>' +
    '</div>';
  }

  /* ===== RENDER ===== */
  function renderUpsell() {
    var grid = document.getElementById("upsellGrid");
    if (!grid) return;
    console.log("[render] Products:", upsellProducts.length);
    if (upsellProducts.length === 0) { grid.innerHTML = '<div class="um-empty">No recommendations available</div>'; return; }

    // Init selections
    upsellProducts.forEach(function(p) {
      if (!selState[p.id]) {
        var av = getAvailSizes(p, p.colors && p.colors[0] || "");
        selState[p.id] = {
          color: p.colors && p.colors[0] || "",
          size: av.length > 0 ? av[Math.min(1, av.length - 1)] : (p.sizes && p.sizes[0] || "")
        };
      }
    });

    // Just added
    var justSec = document.getElementById("umJustAdded");
    if (justAddedProduct) {
      justSec.style.display = "block";
      document.getElementById("umJustImg").src = justAddedProduct.img;
      document.getElementById("umJustName").textContent = justAddedProduct.name;
      document.getElementById("umJustPrice").innerHTML = fmtPrice(justAddedProduct.salePrice) +
        (justAddedProduct.comparePrice > 0 ? ' <span style="text-decoration:line-through;color:#a8a29e;font-size:11px;margin-left:4px;">' + fmtPrice(justAddedProduct.comparePrice) + '</span>' : '');
    } else {
      justSec.style.display = "none";
    }

    // Grid
    grid.innerHTML = upsellProducts.map(function(p) { return buildCard(p); }).join("");
    bindEvents();
  }

  /* ===== BIND EVENTS ===== */
  function bindEvents() {
    var grid = document.getElementById("upsellGrid");

    // Color click
    grid.querySelectorAll(".um-csw").forEach(function(el) {
      el.addEventListener("click", function(e) {
        e.stopPropagation();
        var pid = Number(el.dataset.pid), val = el.dataset.val;
        if (!selState[pid]) selState[pid] = {};
        selState[pid].color = val;
        var p = upsellProducts.find(function(x) { return x.id === pid; });
        var av = getAvailSizes(p, val);
        if (!av.includes(selState[pid].size)) selState[pid].size = av.length > 0 ? av[0] : "";
        updateSingleCard(pid);
        updateCardImage(pid, val);
      });
    });

    // Size click
    grid.querySelectorAll(".um-sch").forEach(function(el) {
      el.addEventListener("click", function(e) {
        e.stopPropagation();
        if (el.disabled) return;
        var pid = Number(el.dataset.pid), val = el.dataset.val;
        if (!selState[pid]) selState[pid] = {};
        selState[pid].size = val;
        var card = el.closest(".um-card");
        card.querySelectorAll(".um-sch").forEach(function(s) { s.classList.remove("picked"); });
        el.classList.add("picked");
      });
    });

    // ADD click
    grid.querySelectorAll(".um-add").forEach(function(el) {
      el.addEventListener("click", function(e) {
        e.stopPropagation();
        var pid = Number(el.dataset.pid);
        if (inCart(pid)) return;
        var p = upsellProducts.find(function(x) { return x.id === pid; });
        if (!p) return;
        var st = selState[pid] || {};
        var variant = findVariant(p, st.color, st.size);
        console.log("[ADD]", p.name, "variant:", variant.id, "color:", st.color, "size:", st.size);
        el.textContent = "Adding..."; el.style.opacity = "0.6";
        addToCartAPI(variant.id, 1)
          .then(function() { return fetchCart(); })
          .then(function() {
            el.classList.add("added"); el.textContent = "ADDED ✓"; el.style.opacity = "1";
            var card = el.closest(".um-card"), iw = card.querySelector(".um-card-img");
            if (!iw.querySelector(".um-ck")) {
              var d = document.createElement("span"); d.className = "um-ck";
              d.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';
              iw.appendChild(d);
            }
            updateFooterCount();
            showToast(p.name + " added!", "ok");
          })
          .catch(function(err) { console.error("[ADD] error:", err); el.textContent = "ADD"; el.style.opacity = "1"; });
      });
    });
  }

  function updateSingleCard(pid) {
    var p = upsellProducts.find(function(x) { return x.id === pid; }); if (!p) return;
    var card = document.querySelector('.um-card[data-pid="' + pid + '"]'); if (!card) return;
    var st = selState[pid], av = getAvailSizes(p, st.color);
    card.querySelectorAll(".um-csw").forEach(function(el) { el.classList.toggle("picked", el.dataset.val === st.color); });
    var ne = card.querySelector(".um-color-name"); if (ne) ne.textContent = st.color;
    card.querySelectorAll(".um-sch").forEach(function(el) { var s = el.dataset.val, ia = av.indexOf(s) !== -1; el.disabled = !ia; el.classList.toggle("picked", s === st.size && ia); });
  }

  function updateCardImage(pid, cn) {
    var p = upsellProducts.find(function(x) { return x.id === pid; });
    if (!p || !p.colorImages) return;
    var sw = p.colorImages.find(function(s) { return s.name === cn; });
    if (!sw || !sw.fullImg) return;
    var card = document.querySelector('.um-card[data-pid="' + pid + '"]');
    if (!card) return;
    var img = card.querySelector(".um-card-img img");
    if (img) {
      img.style.opacity = "0.4";
      img.src = sw.fullImg;
      img.onload = function() { img.style.opacity = "1"; };
    }
  }
  /* ===== OPEN / CLOSE ===== */
  window.openUpsell = function(productId, productHandle) {
    console.log("[openUpsell] productId:", productId, "handle:", productHandle);

    // ===== FIRST-TIME CONDITION =====
    // If product already in cart, DON'T show popup — open cart drawer instead
    if (inCart(productId)) {
      console.log("[openUpsell] Product already in cart — skipping popup, opening cart");
      openShopflowCartDrawer();
      return;
    }

    var modal = document.getElementById("upsellModal"), grid = document.getElementById("upsellGrid");
    if (!modal || !grid) { console.error("[openUpsell] Modal/grid not found!"); return; }

    grid.innerHTML = '<div class="um-loading">Loading...</div>';
    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    // ===== ADD BLUR TO BODY =====
    document.body.classList.add("um-blur");

    blockShopflowPopup(true);

    // Fetch just-added product
    var justAddedPromise;
    if (productHandle) {
      justAddedPromise = fetchProductByHandle(productHandle);
    } else {
      justAddedPromise = Promise.resolve(null);
    }

    justAddedPromise.then(function(jp) {
      justAddedProduct = jp;
      console.log("[openUpsell] Just added:", jp ? jp.name : "null");
      return Promise.all([fetchCart(), getUpsellProducts(productHandle)]);
    }).then(function(res) {
      upsellProducts = res[1];
      console.log("[openUpsell] Loaded", upsellProducts.length, "upsell products");
      renderUpsell();
      updateFooterCount();
    }).catch(function(err) {
      console.error("[openUpsell] Error:", err);
      grid.innerHTML = '<div class="um-empty">Could not load</div>';
    });
  };

  window.umCloseAndCart = function() {
    console.log("[close] Closing modal, opening cart");
    var modal = document.getElementById("upsellModal");
    if (modal) modal.classList.remove("active");
    document.body.style.overflow = "";

    // ===== REMOVE BLUR =====
    document.body.classList.remove("um-blur");

    blockShopflowPopup(false);
    setTimeout(function() { openShopflowCartDrawer(); }, 300);
  };

  function updateFooterCount() {
    var el = document.getElementById("umCartCount");
    if (el) el.textContent = cartCount();
  }

  /* ===== SHOPFLOW CART ===== */
  function openShopflowCartDrawer() {
    var sels = [
      '[aria-controls="CartDrawer"]','[aria-controls="cart-drawer"]',
      '[data-cart-drawer-trigger]','[data-cart-drawer-toggle]','[data-open-cart-drawer]',
      '[data-cart-toggle]','[data-drawer="cart"]','[aria-label="Cart"]',
      ".cart-drawer-trigger",".cart-drawer-toggle",".header__icon--cart",
      ".cart-icon-bubble",".cart-link",".cart-button",".js-cart-drawer-open","#cart-icon-btn"
    ];
    for (var i = 0; i < sels.length; i++) { var t = document.querySelector(sels[i]); if (t) { t.click(); return; } }
    var dw = document.querySelector("#CartDrawer,#cart-drawer,.cart-drawer,.cart-drawer-container,.drawer--cart,[data-cart-drawer],cart-drawer");
    if (dw) { if (typeof dw.open==="function") { dw.open(); return; } if (typeof dw.show==="function") { dw.show(); return; } dw.classList.add("active","is-open","open"); dw.setAttribute("open",""); return; }
    if (window.Shopify&&Shopify.theme&&Shopify.theme.cartDrawer&&typeof Shopify.theme.cartDrawer.open==="function") { Shopify.theme.cartDrawer.open(); return; }
    try { document.dispatchEvent(new CustomEvent("cart:open",{bubbles:true})); document.dispatchEvent(new CustomEvent("cart-drawer:open",{bubbles:true})); document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open",{bubbles:true})); document.dispatchEvent(new CustomEvent("shopflow:cart:open",{bubbles:true})); } catch(e) {}
    var ab = document.querySelector(".push-cart-dialog [aria-label='Cart'],.push-cart-trigger,[data-push-cart-toggle]");
    if (ab) { ["mousedown","mouseup","click"].forEach(function(ev) { ab.dispatchEvent(new MouseEvent(ev,{view:window,bubbles:true,cancelable:true})); }); }
  }

  function blockShopflowPopup(b) {
    var p = document.querySelector(".push-cart-dialog,.push-cart-popup,[data-push-cart]");
    if (p) { if (b) { p.style.display="none"; p.setAttribute("aria-hidden","true"); p.classList.remove("active","is-open","open"); } else { p.style.display=""; } }
  }

  ["shopflow:cart:open","dispatch:cart-drawer:open","cart:open","cart-drawer:open","open-cart-drawer","ajaxCart:open"].forEach(function(en) {
    document.addEventListener(en, function(e) {
      var m = document.getElementById("upsellModal");
      if (m && m.classList.contains("active")) { e.stopImmediatePropagation(); e.preventDefault(); }
    }, true);
  });

  /* ===== INTERCEPT ADD TO CART ===== */
  document.addEventListener("submit", function(e) {
    var form = e.target;
    if (!form.action || !form.action.indexOf("/cart/add") === -1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    console.log("[intercept] Form /cart/add");
    var fd = new FormData(form);
    fetch("/cart/add.js", { method: "POST", body: fd, credentials: "same-origin" })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        console.log("[intercept] Added, product_id:", data.product_id, "handle:", data.handle);
        var pid = (window.upsellConfig && window.upsellConfig.currentProductId) || data.product_id;
        var handle = (window.upsellConfig && window.upsellConfig.currentHandle) || data.handle || "";
        openUpsell(pid, handle);
        showToast("Added to bag!", "ok");
      })
      .catch(function(err) { console.error("[intercept] Error:", err); form.submit(); });
  }, true);

  // Intercept fetch
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = typeof arguments[0] === "string" ? arguments[0] : (arguments[0] && arguments[0].url) || "";
    if (url.includes("/cart/add")) {
      return origFetch.apply(this, arguments).then(function(resp) {
        resp.clone().json().then(function(data) {
          if (data.id || data.variant_id) {
            var m = document.getElementById("upsellModal"); if (m && m.classList.contains("active")) return;
            var pid = (window.upsellConfig && window.upsellConfig.currentProductId) || data.product_id;
            var handle = (window.upsellConfig && window.upsellConfig.currentHandle) || data.handle || "";
            setTimeout(function() { openUpsell(pid, handle); }, 80);
            showToast("Added to bag!", "ok");
          }
        }).catch(function() {}); return resp;
      });
    }
    return origFetch.apply(this, arguments);
  };

  /* ===== TOAST ===== */
  function showToast(msg, type) {
    var box = document.querySelector(".um-toast");
    if (!box) { box = document.createElement("div"); box.className = "um-toast"; document.body.appendChild(box); }
    var t = document.createElement("div");
    t.className = "um-toast-item um-toast-" + (type || "ok");
    t.textContent = msg; box.appendChild(t);
    setTimeout(function() { t.remove(); }, 2400);
  }

  /* ===== ESC KEY ===== */
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") { var m = document.getElementById("upsellModal"); if (m && m.classList.contains("active")) umCloseAndCart(); }
  });

  /* ===== INIT ===== */
  document.addEventListener("DOMContentLoaded", function() {
    console.log("[init] DOM ready");
    fetchCart();
    console.log("[init] upsellConfig:", JSON.stringify(window.upsellConfig));
  });

})();